const PHONE_TYPE_SELECT_OPTIONS = [
    { value: "Home", label: "Home" },
    { value: "Mobile", label: "Cell" },
    { value: "Business", label: "Work" },
];

export default PHONE_TYPE_SELECT_OPTIONS;
